export default "__VITE_ASSET__BKkL90dk__"